import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function CheckoutTipSection({ tip, setTip, primaryColor }) {
  const { t } = useTranslation();
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">{t('checkout.tipOptional')}</h2>
      <div className="grid grid-cols-4 gap-3">
        {[0, 500, 1000, 1500].map((amount) => (
          <Button
            key={amount}
            variant={tip === amount ? 'default' : 'outline'}
            onClick={() => setTip(amount)}
            style={tip === amount ? { backgroundColor: primaryColor } : {}}
          >
            {amount === 0 ? t('checkout.noTip') : `$${amount}`}
          </Button>
        ))}
      </div>
    </Card>
  );
}
